const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAllAssetsApi = async () => {
  const token = localStorage.getItem('token'); 

  if (!token) {
    console.error('[getAllAssetsApi] Ошибка: Токен авторизации не найден.');
    throw new Error('Токен авторизации не найден.'); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/common/trade/assets`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    console.log(response); 

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[getAllAssetsApi] Ошибка получения активов:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    console.log("Полученные активы:", data); 
    return data.data || []; 
  } catch (error) {
    console.error('[getAllAssetsApi] Ошибка сети или другая ошибка:', error);
    throw error;
  }
};